import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { AuthService } from 'src/app/service/core/auth.service';

@Injectable()
export class AlterarSenhaGuard implements CanActivate {

  constructor(private auth: AuthService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.alteracaoSenha.login || this.auth.usuario) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
